import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-primary-dark text-slate-300 py-16 font-sans border-t border-slate-800">
      <div className="section-container">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand Info */}
          <div>
            <h2 className="text-2xl font-display font-bold text-white mb-6">POWER TECH</h2>
            <p className="mb-6 leading-relaxed text-slate-400">
              하네스 케이블과 제어 시스템의 혁신 파트너.<br />
              고객사의 생산성 향상을 위한<br />
              최고의 솔루션을 제공합니다.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold text-white mb-6">바로가기</h3>
            <ul className="space-y-3">
              {['회사소개', '제품소개', '설비현황', '견적문의', '오시는 길'].map((item) => (
                <li key={item}>
                  <span className="hover:text-white hover:translate-x-1 transition-all duration-300 inline-block cursor-pointer">
                    {item}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-bold text-white mb-6">주요 서비스</h3>
            <ul className="space-y-3">
              <li>산업용 하네스 제조</li>
              <li>자동화 제어박스 설계</li>
              <li>전장 시스템 구축</li>
              <li>맞춤형 케이블 어셈블리</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-bold text-white mb-6">연락처</h3>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <MapPin className="text-accent mt-1 flex-shrink-0" size={20} />
                <span>충청남도 천안시 서북구<br />백석공단1로 70</span>
              </li>
              <li className="flex items-center space-x-3">
                <Phone className="text-accent flex-shrink-0" size={20} />
                <span>041-576-7573</span>
              </li>
              <li className="flex items-center space-x-3">
                <Mail className="text-accent flex-shrink-0" size={20} />
                <span>ygm1028@powerteck.co.kr</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 pt-8 flex flex-col md:flex-row justify-between items-center text-sm text-slate-500">
          <p>&copy; 2024 Power Technology Inc. All rights reserved.</p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <span className="hover:text-white transition-colors cursor-pointer">개인정보처리방침</span>
            <span className="hover:text-white transition-colors cursor-pointer">이용약관</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
